/**
 * Wire-format `OrderStatus` — the 7-state user-facing lifecycle as seen
 * by mobile / admin clients via REST responses, Socket.IO payloads, and
 * chat `contract_card` / `status_event` messages.
 *
 * Distinct from the backend's `Prisma.OrderStatus` enum (in
 * `packages/api/prisma/schema.prisma`), which has 11 fine-grained
 * internal states. The 4 internal states that aren't exposed on the
 * wire (`draft`, `awaiting_payment`, `report_submitted`, `released`,
 * `expired`, `disputed`) get folded into the closest external state by
 * the backend mapper (see `packages/api/src/modules/chat/order-status.wire.ts`).
 *
 * Centralised in `@carcheck/shared` so client packages can import the
 * enum + type without bringing in a Prisma client dependency. Mirror
 * any addition here in `OrderStatusBackendMap` on the API side so the
 * narrowing test catches drift.
 */
export const OrderStatusWire = {
    Proposed: 'proposed',
    Accepted: 'accepted',
    Paid: 'paid',
    InProgress: 'in_progress',
    Completed: 'completed',
    Cancelled: 'cancelled',
    Refunded: 'refunded',
};
export const ORDER_STATUS_WIRE_VALUES = Object.values(OrderStatusWire);
export function isOrderStatusWire(value) {
    return typeof value === 'string' && ORDER_STATUS_WIRE_VALUES.includes(value);
}
//# sourceMappingURL=order-status.js.map